/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/contexts/CustomContextHook/useAuth'
// import { useHotel } from '../../../../app/contexts/CustomContextHook/useHotel'
import { useHotel2 } from '../../../../app/contexts/HotelContext'

import { IsAuthorizedContext } from '../../../../app/contexts/isAuthorizedContext'
import { KTSVG, toAbsoluteUrl, defaultAlerts, defaultLogs } from '../../../helpers'

const HeaderNotificationsMenu = () => {

  // const isAuthorizedCxt = useContext(IsAuthorizedContext);
  const { UserToken, setUserToken } = useAuth('')
  // const { Hotel, setHotel } = useHotel()

  const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2()

  const logout = () => {

    // console.log('UserToken---', UserToken);


    

    // localStorage.setItem('Token', '');
    // localStorage.setItem('Expiry', '');
    // localStorage.setItem('LoggedInUserId', '');
    // localStorage.setItem('UserRoles', []);
    // localStorage.setItem('FirstName', '');
    // localStorage.setItem('LastName', '');
    // localStorage.setItem('Email', '');

    setHotelId('0');
    setHotelName("");

    localStorage.setItem("SignOut", true);

        
    localStorage.removeItem("WeeklyWrapUpObj");
    localStorage.removeItem("WeeklyWrapUpObjEditedHotelId");
    localStorage.removeItem('ReturnURL');
    localStorage.removeItem('FormEditingMode');
    localStorage.removeItem('IsEditOperation');


    localStorage.removeItem('PayrollReportObjEditedHotelId');
    localStorage.removeItem('PayrollReportObjFormEditingMode');
    localStorage.removeItem('IsPayrollReportObjEditOperation');
    localStorage.removeItem('PayrollReportReturnURL');
    localStorage.removeItem('PayrollReportObj');


    setUserToken('', '', '', [], '', '', '');

  }


  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-250px text-justify'
      data-kt-menu='true'
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{ backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')` }}
      >
        <h6 className='text-white  px-4 mt-4 mb-2'> {UserToken.FirstName} {UserToken.LastName} ({UserToken.Roles.map(a => {return( <span>{a.replace('"',"").replace('"',"").replace("[","").replace("]","")},</span>) })})</h6>
        <div className='row'>
          <h6 className='text-white px-4  mt-4 mb-2 text-justify col-12 text-truncate'> {UserToken.Email} </h6>
        </div>
        {/* <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Account Settings */}
        {/* <span className='fs-8 opacity-75 ps-3'>24 reports</span> */}
        {/* </h3> */}

        {/* <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_1'
          >
            Alerts
          </a>
        </li>

        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4 active'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_2'
          >
            Updates
          </a>
        </li>

        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_3'
          >
            Logs
          </a>
        </li>
      </ul> */}
      </div>

      <div className='tab-content'>


        <div className='tab-pane fade show active' id='kt_topbar_notifications_2' role='tabpanel'>
          <div className='d-flex flex-column px-9'>
            <div className='pt-10 pb-0'>
              {/* <h3 className='text-dark text-center fw-bolder'>Get Pro Access</h3> */}

              {/* <div className='text-center text-gray-600 fw-bold pt-1'>
              Outlines keep you honest. They stoping you from amazing poorly about drive
            </div> */}

              <div className='text-center mt-5 mb-9'>
                <a
                  className='btn btn-sm btn-primary px-6'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_upgrade_plan'
                  onClick={logout}
                >
                  Logout
                </a>
              </div>
            </div>


          </div>
        </div>


      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }
